import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";

import { classNames } from "@/react/helpers/twMergeWithCN";

import { usePaywallCustomizationContext } from "../../PaywallCustomizationProvider";
import { CoverImage } from "./CoverImage";
import { CoverVideo, type CoverVideoProps } from "./CoverVideo";

interface CoverProps {
  className?: string;
  isPreviewing?: boolean;
  mediaClassName?: string;
  overrideVideoProperties?: CoverVideoProps["overrideVideoProperties"];
}

export const Cover = Object.assign(
  ({
    className,
    mediaClassName,
    isPreviewing,
    overrideVideoProperties,
  }: CoverProps) => {
    const { paywallCustomization } = usePaywallCustomizationContext();

    const detailedProperties = paywallCustomization?.detailed_properties;
    const isVideo = !!detailedProperties?.cover?.content_type?.match(/video\//);

    if (isVideo) {
      return (
        <CoverVideo
          className={className}
          cover={detailedProperties?.cover}
          videoProperties={detailedProperties?.cover_video_properties}
          isPreviewing={isPreviewing}
          videoClassName={mediaClassName}
          overrideVideoProperties={overrideVideoProperties}
        />
      );
    }

    const imageUrl = detailedProperties?.cover?.url;
    if (imageUrl || paywallCustomization?.cover_image_url) {
      return (
        <CoverImage
          className={className}
          imageUrl={imageUrl || paywallCustomization?.cover_image_url || ""}
          imageClassName={mediaClassName}
        />
      );
    }

    return null;
  },
  {
    Image: CoverImage,
    Skeleton: () => (
      <div className={classNames("grid place-items-center h-full")}>
        <Row
          square
          className="size-full md:!h-[404px] lg:!h-[432px] md:!w-[768px]"
          data-testid="cover-image"
        />
      </div>
    ),
    Video: CoverVideo,
  },
);
